import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgIf} from '@angular/common';
import {FormLoginComponent} from '../login-register/form-login.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthenticationService} from '../../../../services/authentication.service';
import {MatInputModule} from '@angular/material/input';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../services/user-services/user.service';
import {User} from '../../../../models/user';
import {ProcessService} from '../../../../services/user-services/process.service';
import {first, take} from 'rxjs/operators';
import {AlertService} from '../../../../services/alert.service';

@Component({
  selector: 'app-report-form',
  standalone: true,
  imports: [
    NgIf,
    FormLoginComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    TranslateModule
  ],
  templateUrl: './report-form.component.html',
  styleUrl: './report-form.component.scss'
})
export class ReportFormComponent implements OnInit {
  @Input() public item: any;

  public form: FormGroup = new FormGroup({
    user: new FormControl<any>(null, {nonNullable: true}),
    report: new FormControl<string>(null, {nonNullable: true, validators: [Validators.required, Validators.minLength(20)]}),
  });

  public isLogged: boolean = false;
  public formError: string = null;
  public page: number = 0;
  private user: User;

  constructor(
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private processService: ProcessService,
    private alertService: AlertService,
    private _translateService: TranslateService,
  ) {
  }

  ngOnInit(): void {
    if (this.authenticationService.currentUserValue) {
      this.isLogged = true;
      this.user = this.userService.getInfos();
      this.form.controls.user.setValue(this.user);
      //On check s'il a déjà fait un report, on le récupère pour qu'il le mette à jour
      this.processService.getReport(this.item.id, 'property').pipe(take(1)).subscribe(data => {
        if (data && data.report) {
          this.form.controls.report.setValue(data.report.content);
        }
      });

    }
  }

  public openReportModale(modaleName): void {
    this.page = 0;
    this.formError = null;
    this.modalService.open(modaleName, {size: 'lg', centered: true});
  }


  public submit(): void {
    this.formError = null;
    if (this.isLogged) {
      if (this.form.valid) {
        this.processService.sendReport(this.item.id, 'property', this.form.controls.report.value.toString()).pipe(first()).subscribe(data => {
          const msg = this._translateService.instant('COMMON.REPORT.REPORT_SEND');
          this.alertService.openSnackBar(msg, 'snack-success');
          this.page += 1;
        }, (error) => {
          this.formError = error;
        });
      } else {
        if (!this.form.controls.report.value) {
          this.formError = 'COMMON.IS_REQUIRED';
        } else if (this.form.controls.report.value.length < 20) {
          this.formError = 'COMMON.REPORT.MINIMUM_WORDING_ERROR';
        } else {
          this.formError = 'COMMON.REPORT.RANDOM_ERROR';
        }
      }
    } else {
      this.formError = 'COMMON.REPORT.NOT_LOGGED_ERROR';
    }

    if (this.formError) {
      const msg = this._translateService.instant(this.formError);
      this.alertService.openSnackBar(msg, 'snack-error');
    }

  }

}
